import { Component, OnInit } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { PreviousLevelsPageService } from './previous-levels-page.service';

@Component({
  selector: 'lp2-industry-content-previous-levels-page',
  templateUrl: './previous-levels-page.component.html',
  styleUrls: ['./previous-levels-page.component.scss'],
})
export class PreviousLevelsPageComponent implements OnInit {
  currentLevel: number;
  industry: string;
  previousLevels$ = this.previousLevelsPageService.state$;

  constructor(
    private previousLevelsPageService: PreviousLevelsPageService,
    private oeAppPersonService: OeAppPersonService
  ) {}

  ngOnInit() {
    this.currentLevel = this.oeAppPersonService.levelNum;
    this.industry = this.previousLevelsPageService.getSelectedIndustry();
    this.previousLevelsPageService.updatePreviousLevels();
  }
}



// WEBPACK FOOTER //
// ./ts/app/industry-content/previous-levels-page/previous-levels-page.component.ts